export default "__VITE_ASSET__B$j1pyO8__"